import React from 'react';
import { Box, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

const OrganizationListRow = ({ organization, selected = false, index, onClick, disabled = false, showTrn = false }) => {
    const rowRadius = '8px';

    return (
        <Box
            role="button"
            tabIndex={disabled ? -1 : 0}
            onClick={disabled ? undefined : onClick}
            onKeyDown={(event) => {
                if (disabled) {
                    return;
                }

                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onClick?.();
                }
            }}
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1.5,
                px: 1.5,
                py: 1,
                mb: 0.5,
                borderRadius: rowRadius,
                cursor: disabled ? 'default' : 'pointer',
                bgcolor: index%2 === 0 ? '#fafafa' : 'transparent',
                color:  'text.primary',
                opacity: disabled ? 0.6 : 1,
                transition: 'background-color 0.15s ease',
                '&:hover': disabled
                    ? {}
                    : {
                        bgcolor: 'action.hover',
                        borderRadius: rowRadius,
                    },
            }}
        >
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 450,
                        lineHeight: 1.4,
                        color: 'inherit',
                    }}
                >
                    {organization.name}
                </Typography>

            </Box>
            {selected ?<DoneIcon
                sx={{
                     fontSize: 20,
                     mt: 0.25,
                     color: 'primary.main',
                 }}/>:null
            }
        </Box>
    );
};

export default OrganizationListRow;